import React, { PropsWithChildren } from 'react';
import Box from '@mui/material/Box';
import { getMembershipTierDisplayName } from '@yi/core';
import { i18n_member_discount } from '@yi/i18n/phrases/i18n_member_discount';

import { useLocale } from '~/components';

import type { PriceInfo } from './PriceInfo';

interface Props {
  price: number;
  discount: PriceInfo['discount'];
  testId?: string;
}

const MemberDiscountText: React.FC<PropsWithChildren<{ discount: Props['discount'] }>> = ({
  discount,
}) => {
  const { locale } = useLocale();
  if (!discount || !('membershipTier' in discount)) return null;
  const { value } = discount;
  const membershipTier = discount.membershipTier;
  if (membershipTier === null) {
    return null;
  }

  const membershipTierDisplayName = getMembershipTierDisplayName(membershipTier);
  const memberDiscountMessage =
    'percentOff' in value &&
    membershipTier &&
    `${value.percentOff}% ${membershipTierDisplayName} ${i18n_member_discount(locale)}`;

  return <Box fontSize={12}>{memberDiscountMessage}</Box>;
};

export const DiscountText: React.FC<PropsWithChildren<Props>> = ({ price, testId, discount }) => {
  let returnText = '';

  if (price) {
    const buttonPrice = price !== null ? price : 0;
    let replaceText = '';
    if (discount && 'amountOff' in discount.value) {
      replaceText = `<del>&#36;${buttonPrice}</del>&nbsp;&#36;${Math.floor(
        buttonPrice - discount.value.amountOff,
      )}`;
    } else if (discount && 'percentOff' in discount.value) {
      replaceText = `<del>&#36;${buttonPrice}</del>&nbsp;&#36;${Math.floor(
        buttonPrice * (1 - discount.value.percentOff / 100),
      )}`;
    } else {
      replaceText = `&#36;${buttonPrice}`;
    }
    returnText = `<div>${replaceText} USD</div>`;
  }

  return (
    <>
      <div data-testid={testId} dangerouslySetInnerHTML={{ __html: returnText }} />
      {discount && <MemberDiscountText discount={discount} />}
    </>
  );
};
